import { parseTheme } from 'mol-ui';
import styled from 'styled-components';

export const ContentPercent = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${ ({ theme: { borderColor } }) => borderColor };
    margin-bottom: 10px;
    padding-bottom: 10px;

    &:last-child {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
    }
`;
ContentPercent.displayName = 'ContentPercent';

export const Image = styled.img`
    height: 40px;
`;
Image.displayName = 'Image';

export const Text = styled.span`
    ${ parseTheme('color', 'primaryColor') }
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
    text-transform: uppercase;
    margin: 20px;
`;
Text.displayName = 'Text';

export const Title = styled.p`
    color: ${ ({ theme: { textColor } }) => textColor };
    font-weight: 500;
    margin: 0 0 5px 0;
`;
Title.displayName = 'Title';

export const Subtitle = styled.span`
    color: ${ ({ theme: { textColor } }) => textColor };
    font-size: 0.8rem;
    font-weight: 500;
    margin: 0 0 5px 0;
`;
Subtitle.displayName = 'Subtitle';

export const TextContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items:center;
`;

export const ContentBarChart = styled.div`
    display: ${ ({ active }) => active ? 'block' : 'none' }
`;
